class AccountSettings.SearchView extends Backbone.View

  template: JST['backbone/templates/account_settings/topics/search']

  events:
    'click .search-btn': 'onClickSearch'
    'click .clearable__clear': 'onClickResetSearch'
    'input .input-medium' : 'onInputSearchBox'
    'keypress .input-medium' : 'onKeyPressSearchBox'

  render: ->
    @$el.html(@template())
    @

  onKeyPressSearchBox:(event)->
    if(event.keyCode == 13)
      @onClickSearch(event)

  onClickSearch:(event)->
    @searchingText = @$('.input-medium')[0].value
    if @searchingText
      @trigger('hashtag:search:begin', @searchingText)
      event.preventDefault()

  onClickResetSearch:(event)->
    event.preventDefault()
    inp = @$el.find(".input-medium");
    inp.val("").trigger("input");
    @trigger('hashtag:search:reset')

  onInputSearchBox: (event) ->
    @$el.find(".clearable__clear").toggle(!!event.target.value);

